import { HTMLAttributes, useMemo, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';

import { IconButton } from '@/shared/ui/Button/IconButton';
import Arrow from '@/assets/icons/white_arrow.svg?react';
import { cn } from '@/shared/lib/utils';

import { Pagination } from 'swiper/modules';


interface IFloorPlanSliderProps extends HTMLAttributes<HTMLDivElement> {
    slides: string[]
    spaceBetween?: number,
    className?: string,
}

export function FloorPlanSlider({ slides, spaceBetween, className, children }: IFloorPlanSliderProps) {

    const swiperRef = useRef<SwiperType | null>(null);

    const handleSwiperNext = () => {
        if (swiperRef.current) swiperRef.current.slideNext()
    }

    const handleSwiperPrev = () => {
        if (swiperRef.current) swiperRef.current.slidePrev()
    }

    const images = useMemo(()=>{
        if(!slides || slides.length == 0) return ['/images/schema_default_img.png'];
        else return slides;
    }, [slides]);

    return (
        <div className={cn('w-[inherit] h-[inherit] overflow-hidden relative', className)} >


            <IconButton
                className='absolute bg-black right-0 top-1/2 -translate-y-1/2 z-10 w-[40px] h-[40px]'
                icon={<Arrow className='h-[18px] w-[9px] stroke-white'/>}
                onClick={handleSwiperNext}
            />
            <IconButton
                className='absolute bg-black left-0 top-1/2 -translate-y-1/2 z-10 w-[40px] h-[40px]'
                icon={<Arrow className='h-[18px] w-[9px] rotate-180 stroke-white'/>}
                onClick={handleSwiperPrev}
            />

            <Swiper
                direction="horizontal"
                slidesPerView='auto'
                spaceBetween={spaceBetween}
                pagination={{ clickable: true }}
                modules={[Pagination]}
                className="floor-plan-swiper h-auto w-full md:w-[391px]"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {
                    images.map((item, index) => (
                        <SwiperSlide key={index} className='overflow-hidden w-full  h-[234px] md:h-full'>
                            <div className='w-full h-full overflow-hidden px-[52px]'>
                                <img src={item} alt="" className='w-full h-full object-contain' />
                            </div>
                        </SwiperSlide> 
                    ))
                }
            </Swiper>
            
        </div>
    );
}
